// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"533":"9c17cbc8","846":"a0f68726"}[chunkId] + ".chunk.js";
};